/* istanbul ignore file */
import sDatePicker from './date-picker'
import sCalendarPanel from './calendar/calendar-panel'
import sCalendarRange from './calendar/calendar-range'
import sTimePanel from './time/time-panel'
import sTimeRange from './time/time-range'
import sDatetimePanel from './datetime/datetime-panel'
import sDatetimeRange from './datetime/datetime-range'
import { locale } from './locale'

sDatePicker.locale = locale

sDatePicker.install = function install(Vue) {
  Vue.component(sDatePicker.name, sDatePicker)
}

if (typeof window !== 'undefined' && window.Vue) {
  sDatePicker.install(window.Vue)
}

Object.assign(sDatePicker, {
  sCalendarPanel,
  sCalendarRange,
  sTimePanel,
  sTimeRange,
  sDatetimePanel,
  sDatetimeRange,
})

export default sDatePicker